import { Table } from 'antd';
import styled from 'styled-components';

import type { DashboardCardInfoT } from '@/features/Dashboard/types';
import { customScrollbar } from '@/styles/style';

import ChartTableConfigProvider from '../chart-table-config-provider';
import useChartCrossTableData from './useChartCrossTableData.v2';

type Props = {
  chart: ChartBase & { name: string };
  tableData: ChartCrossTableRes;
  height?: number;
  dashboardCardInfo?: DashboardCardInfoT;
};

const CrossTableChart = (props: Props) => {
  const { columns, dataSource } = useChartCrossTableData(props);

  return (
    <Style style={{ height: props.height || 360 }}>
      <ChartTableConfigProvider>
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          bordered
          scroll={{
            x: 'max-content',
          }}
        />
      </ChartTableConfigProvider>
    </Style>
  );
};

const Style = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  overflow: auto;
  ${customScrollbar};

  .ant-table-wrapper {
    width: 100%;
  }

  .ant-table {
    width: 100%;
  }

  .ant-table-cell {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ant-table-thead th {
    background-color: ${({ theme }) => theme.colors.gray200} !important;
    padding: 10px 16px !important;
    white-space: nowrap;
  }

  .ant-table-row td {
    background-color: ${({ theme }) => theme.colors.gray100};
    padding: 8px 16px !important;
    white-space: nowrap;
    text-align: right; // 숫자 데이터의 경우 우측 정렬
  }

  .ellipsis {
    font-size: 12px;
  }
`;

export default CrossTableChart;
